import React from "react";
import styles from "./Tag.module.scss";
import { BackgroundColor, classForBackground } from "../Backgrounds/background";
import clsx from "clsx";

type Props = {
  backgroundColor?: BackgroundColor;
  size?: "standard" | "large";
  variant?: "default" | "success" | "warning" | "negative";
  className?: string;
  inline?: boolean;
};

export const Tag: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  backgroundColor,
  size = "standard",
  variant = "default",
  inline = false,
  className
}) => {
  const bgClass = classForBackground(backgroundColor);

  return (
    <div
      className={clsx(styles.tag, bgClass, className, {
        [styles.inline]: inline,
        [styles.large]: size == "large",
        [styles.success]: variant == "success",
        [styles.warning]: variant == "warning",
        [styles.negative]: variant == "negative"
      })}
    >
      {children}
    </div>
  );
};
